import './App.css';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import SurveyPage from './components/SurveyPage';
import SurveyResults from './components/SurveyResults';

function App() {
	return (
		<BrowserRouter>
			<Routes>
				<Route path='/' element={<SurveyPage />} />
				<Route path='/:surveyCode' element={<SurveyPage />} />
				<Route path='/:surveyCode/results' element={<SurveyResults />} />
				<Route path='*' Component={() => <Navigate to='/' />}></Route>
			</Routes>
		</BrowserRouter>
	);
}

export default App;
